export const INLINE_BLOCK_NODE_NAME = 'inline-block';
